<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="isBtn"
        color="error"
        class="me-4"
        name="delete"
        :title="'delete ' + id"
        :disabled="disabled"
        v-on="on"
      >
        Reset
        <v-icon
          small
          class="ms-2"
        >
          mdi-delete
        </v-icon>
      </v-btn>
      <v-icon
        v-else
        :size="size"
        class="mx-2"
        name="delete"
        :title="'delete ' + id"
        :disabled="disabled"
        v-on="on"
      >
        mdi-delete
      </v-icon>
    </template>
    <v-card
      title="Are you sure?"
      class="mb-0"
    >
      <v-card-title class="ma-2 text-center d-block">
        <span style="color: red">Are you sure to proceed?</span>
        <br>
        <span style="color: red">This action can not be undone</span>
      </v-card-title>
      <v-divider class="ma-2" />
      <v-card-actions class="ma-2 text-center">
        <v-spacer />
        <v-btn
          color="white"
          name="Cancel"
          class="text-right mr-10"
          @click="_onNo()"
        >
          NO
        </v-btn>
        <v-btn
          color="red"
          name="Add"
          class="text-right ml-10"
          @click="_onYes()"
        >
          YES
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 16
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  created() {
    this.$emit('closeDialog');
  },
  methods: {
    _onYes() {
      this.$emit('deleted', this.id);
      this.dialog = false;
    },
    _onNo() {
      this.dialog = false;
    }
  }
};
</script>
